<template>
    <article class="anchor-card h-full">
        <div class="aspect-w-1 aspect-h-1 rounded-full overflow-hidden">
            <img v-lazy-load class="object-cover w-full h-full" :data-src="img" :alt="name" />
        </div>

        <div class="inline-flex mt-5">
            <button class="audio-control audio-control--play" @click="togglePlayState">
                <i18n tag="span" class="offscreen" path="a11y.play_sound_of_bird">
                    {{ name }}
                </i18n>
                <i class="pi" :class="playing ? 'pi-pause' : 'pi-play'"></i>
            </button>
            <div class="ml-5 text-left">
                <h2 class="font-Poppins text-xl font-semibold uppercase mb-2">{{ name }}</h2>
                <span class="text-lg font-bold">{{ latinName }}</span>
            </div>
        </div>
        <audio ref="audio-player" class="hidden" @play="onPlay" @pause="onPause" @ended="onEnded">
            <source :src="audio" type="audio/mp3" />
        </audio>
    </article>
</template>

<script>
export default {
    name: 'VideoCard',
    props: {
        name: {
            type: String,
            required: true,
        },
        latinName: {
            type: String,
            required: true,
        },
        img: {
            type: String,
            required: true,
        },
        audio: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            playing: false,
        };
    },
    methods: {
        onPlay() {
            this.playing = true;
        },
        onPause() {
            this.playing = false;
        },
        onEnded() {
            this.playing = false;
        },
        togglePlayState() {
            if (this.playing) {
                this.$refs['audio-player'].pause();
            } else {
                this.$refs['audio-player'].play();
            }
        },
    },
};
</script>

<style scoped>
.audio-control {
    @apply w-10 h-10 min-w-[2.5rem] border border-black rounded-full relative;
    i {
        @apply absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2;
    }
}
</style>
